<div class="placemarkDesignPicker">
  <mat-icon class="selectorCloseIcon" svgIcon="dialog.close" (click)="closePopup()"></mat-icon>
  <div class="statusShapeContainer">
    <ins-selection-box class="componentInDialog statusSelection" [options]="statusOptions" [(value)]="status" [label]="'Status:'"
    (isValid)="updateDialogValidity($event)" [validatorCfg]="[validators.Required]" [disabled]="disableStatusSelection"></ins-selection-box>
    <ins-selection-box class="componentInDialog shapeSelection" [options]="shapeOptions" [(value)]="shape" [label]="'Shape:'"
    (isValid)="updateDialogValidity($event)" [validatorCfg]="[validators.Required]"></ins-selection-box>
  </div>
  <div class="colorSelectionContainer">
    <div class="label"><span _ngcontent-ajd-c210="" id="require" class="reqIcon"> * </span>Select Color:</div>
    <div class="customColorSelection">
      <ins-color-picker id="colorPicker" [(value)]="bgColor" [showDefaultSelector]="true" [enableEmptyColor]="false" [label]="'a'"></ins-color-picker>
      <ins-input-box id="selectColor" class="componentInDialog" placeholder="" [hideLabel]="true"></ins-input-box>
      <ins-input-box id="colorInput" class="componentInDialog colorInput" [hideLabel]="true" [placeholder]="'FF00BB'" [(value)]="bgColor"
      (isValid)="updateDialogValidity($event)" [validatorCfg]="colorCodeValidators" [prefixStr]="'#'"></ins-input-box>
    </div>
  </div>
  <div class="buttonContainer">
    @if (!isSavedStatus) {
      <div class="textButton" (click)="removeStatus()">Remove</div>
    }
    <div class="textButton" (click)="addStatus()" [class.disabled]="!isDialogValid">Save</div>
  </div>
</div>